import { render, staticRenderFns } from "./Roll.vue?vue&type=template&id=06a76b5f&scoped=true&"
import script from "./Roll.vue?vue&type=script&lang=js&"
export * from "./Roll.vue?vue&type=script&lang=js&"
import style0 from "./Roll.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Roll.vue?vue&type=style&index=1&id=06a76b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a76b5f",
  null
  
)

export default component.exports